import get from "lodash/get";
import find from "lodash/find";

import { getMonth, getDate, getYear, getHours, getMinutes } from "date-fns";

export function getStoryFromCollection(collection = []) {
  const items =
    collection.items && collection.items.length > 0 ? collection.items.filter(item => item.type === "story") : [];
  const stories = items.map(({ story }) => story) || [];
  return stories;
}

export function getStoryHeading(story = {}) {
  return get(story, ["alternative", "home", "default", "headline"])
    ? get(story, ["alternative", "home", "default", "headline"])
    : get(story, "headline");
}

export const getSlug = (collection, sections = [], navigateTo) => {
  if (navigateTo) {
    if (sections.find(item => item.slug === navigateTo)) {
      return `/${navigateTo}`;
    }
  }

  if (collection && collection.slug) {
    const metadata = Object.keys(get(collection, ["metadata"], {}));
    const isSection = metadata.indexOf("section") !== -1;

    if (isSection && sections.length > 0) {
      const sectionId = collection.metadata.section[0].id;
      const section = sections.find(item => item.id === sectionId);

      if (section && section["parent-id"]) {
        const parentSection = sections.find(item => item.id === section["parent-id"]);

        if (parentSection) {
          return `/${parentSection.slug}/${section.slug}`;
        }
      } else if (section && !section["parent-id"]) {
        return `/${section.slug}`;
      }
    } else {
      return `/collection/${collection.slug}`;
    }
  }

  return "#";
};

export const toBanglaMonth = value => {
  const monthsObj = {
    0: "জানুয়ারী",
    1: "েব্রুয়ারি",
    2: "মার্চ",
    3: "এপ্রিল",
    4: "সোব",
    5: "জুন",
    6: "জুলাই",
    7: "অগাস্ট",
    8: "সেপ্টেম্বর",
    9: "অক্টোবর",
    10: "নভেম্বর",
    11: "ডিসেম্বর"
  };

  return monthsObj[value];
};

export const toBanglaNum = value => {
  const numbersObj = {
    0: "০",
    1: "১",
    2: "২",
    3: "৩",
    4: "৪",
    5: "৫",
    6: "৬",
    7: "৭",
    8: "৮",
    9: "৯",
    ".": ".",
    "-": "-"
  };

  if (isNaN(parseFloat(value)) || isNaN(value - 0)) {
    return "Invalid input type";
  }

  let str = "";

  return (
    value
      .toString()
      .split("")
      .forEach(num => (str += numbersObj[num])),
    str
  );
};

export const getStoryPageDate = publishedTime => {
  const monthname = toBanglaMonth(getMonth(publishedTime));
  const date = toBanglaNum(getDate(publishedTime));
  const year = toBanglaNum(getYear(publishedTime));
  const getHour = getHours(publishedTime);
  const hours = toBanglaNum(getHour > 12 ? getHour - 12 : getHour);
  const merridian = getHour > 12 ? "অপরাহ্ণ" : "পূর্বাহ্ণ";
  const minutes = toBanglaNum(getMinutes(publishedTime));

  return `প্রকাশ: ${date} ${monthname} ${year}, ${hours}:${minutes} ${merridian}`;
};

export const findCompleteSectionUrl = (section, sectionList) => {
  if (section["parent-id"]) {
    const parentSectionObj = find(sectionList, function(item) {
      return section["parent-id"] === item.id;
    });
    return parentSectionObj ? "/" + parentSectionObj.slug + "/" + section.slug : "/#";
  }
  return "/" + section.slug || "#";
};

export function removeDuplicateStories(existingStories, newStories, keyFn = story => story.id) {
  const existingStoryIds = existingStories.map(keyFn);
  return newStories.filter(story => !existingStoryIds.includes(keyFn(story)));
}
